import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginPdfPreview from "filepond-plugin-pdf-preview";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-pdf-preview/dist/filepond-plugin-pdf-preview.min.css";
registerPlugin(FilePondPluginPdfPreview);
const PreviewFileComponent = ({
  optionsFilePond,
}) => {
  return (
    <>
      <FilePond
        files={optionsFilePond.files}
        allowMultiple={optionsFilePond.allowMultiple}
        allowPdfPreview={optionsFilePond.allowPdfPreview}
        server={optionsFilePond.server}
        pdfPreviewHeight={optionsFilePond.pdfPreviewHeight}
        pdfComponentExtraParams={optionsFilePond.pdfComponentExtraParams}
        acceptedFileTypes={optionsFilePond.acceptedFileTypes}
        allowRemove={false}
        labelFileLoading={optionsFilePond.labelFileLoading}
        labelTapToCancel={optionsFilePond.labelTapToCancel}
        // name="files" /* sets the file input name, it's filepond by default */
        // labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
      />
    </>
  );
};
export default PreviewFileComponent;
